import styled from "@emotion/styled";
import {
  VIDEO_CONTAINER_COLOR_GRADIENT,
  MOBILE_SCREEN,
} from "../components/theme";
import { ParagraphHeaderSmall, ParagraphHeader } from "./typography/Paragraph";
import ErrorMessage from "./Error";
import Loading from "./Loading";

const MainContainer = styled.div<{ isVertical?: boolean | undefined }>`
  background: ${VIDEO_CONTAINER_COLOR_GRADIENT};
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  ${MOBILE_SCREEN} {
    display: block;
    margin-bottom: 16px;
  }
  ${({ isVertical }) =>
    isVertical &&
    `
    display: block;
    margin-bottom: 16px;
  `}
`;

const VideoFrame = styled.iframe<{ isVertical?: boolean | undefined }>`
  border-radius: 16px;
  vertical-align: top;
  border: none;
  display: inline-block;
  ${MOBILE_SCREEN} {
    width: 100%;
  }
  ${({ isVertical }) =>
    isVertical &&
    `
    width: 100%;
  `}
`;

const VideoDescription = styled.div`
  padding-left: 16px;
  padding-top: 16px;
  display: inline-block;
  width: fit-content;
  min-width: 100px;
`;

const PaddedErrorMessage = styled(ErrorMessage)`
  padding: 4px 16px;
  height: 40px;
  margin: 56px 0 0 0;
  width: 50%;
  ${MOBILE_SCREEN} {
    width: 100%;
  }
`;
const LoadingContainer = styled(Loading)`
  margin: 56px 0 0 0;
  height="40px";
  width= "100%";
  ${MOBILE_SCREEN} {
    width: 50%;
  }
`;

interface VideoContainerProps {
  videoDetails:
    | {
        youtubeLink: string;
        title: string;
        author: string;
      }
    | undefined;
  videoError?: string | undefined;
  isVideoLoading?: boolean | undefined;
  isVertical?: boolean | undefined;
}

const VideoContainer: React.FC<VideoContainerProps> = ({
  videoDetails,
  videoError,
  isVideoLoading,
  isVertical,
}) => {
  if (videoError) {
    return <PaddedErrorMessage>{videoError}</PaddedErrorMessage>;
  }
  if (isVideoLoading) {
    return <LoadingContainer />;
  }
  // If we somehow got here without either videoDetails, return null
  if (!videoDetails) {
    return null;
  }

  return (
    <MainContainer isVertical={isVertical}>
      <VideoFrame
        isVertical={isVertical}
        src={`https://www.youtube.com/embed/${videoDetails.youtubeLink}`}
        title={videoDetails.title}
        allowFullScreen
      />

      <VideoDescription>
        <ParagraphHeader fontWeight={600} marginBottom="8px">
          {videoDetails.title}
        </ParagraphHeader>
        <ParagraphHeaderSmall>
          {videoDetails.author.split("\n")[0]}
        </ParagraphHeaderSmall>
        <ParagraphHeaderSmall>
          {videoDetails.author.split("\n")[1]}
        </ParagraphHeaderSmall>
      </VideoDescription>
    </MainContainer>
  );
};

export default VideoContainer;
